import { render, staticRenderFns } from "./hapus.vue?vue&type=template&id=3407a646"
import script from "./hapus.vue?vue&type=script&lang=js"
export * from "./hapus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports